import React from 'react';
import {
  Container,
  Row,
  Col,
} from 'react-bootstrap';
import { aboutUser} from '../../../const/about_user';

function Footer() {

  const currentYear = new Date().getFullYear()
  return (
    <Container className="footer" fluid={true}>
      <Row >
        <Col xl={12}>
  Copyright © {currentYear !== 2020 && "2020-"}{currentYear} <strong>{aboutUser.fullName}</strong> ,  <small> V1.0 </small>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
